import { colorPalettes } from '@shared/colors/color-palettes';

const primary = colorPalettes.pastel_01;
const secondary = colorPalettes.strongPalette;

export const BASELINE_COLORS = [...primary.base];
export const STRESS_COLORS = [...primary.stress];
export const BASELINE_COLORS_ALTERNATIVE = [...secondary.base];
export const STRESS_COLORS_ALTERNATIVE = [...secondary.stress];
